Ext.define('SA.view.legend.OutlineOptions', {
    alias: 'widget.legend-outline-options',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-legend-outline',

    colorTpl: new Ext.XTemplate(
        '<span class="sa-legend-outline-color-button-swatch" style="background:#{.};"></span>'
    ),

    items: [
        {
            xtype: 'component',
            cls: 'sa-legend-outline-label sa-legend-edit-control-label',
            margin: '0 4 5',
            renderTpl: '{[SA.localize("Outline Thickness and Color")]}'
        }, {
            xtype: 'combo-button',
            cls: 'sa-legend-outline-thickness-button',
            emptyText: '\u00a0',
            itemId: 'outlineThickness',
            items: [0, 1, 2, 3, 4, 5],
            width: 87,

            selectHandler(thickness) {
                var legendView = this.up('map-legend'),
                    map = legendView.map,
                    legend = map.getLegendSettings();

                if (legend.outline.width !== thickness) {
                    map.setLegend({
                        outline: Ext.applyIf({width: thickness}, legend.outline)
                    });
                }
            },

            showMenu() {
                var menu = this.getMenu(),
                    isDark = this.up('map-legend').hasCls('sa-legend-dark');

                menu.ifCls(isDark, 'sa-legend-menu-dark');
                menu.ifCls(!isDark, 'sa-legend-menu-light');

                return this.self.prototype.showMenu.apply(this, arguments);
            }
        }, {
            xtype: 'sa-menu-button',
            cls: 'sa-legend-outline-color-button sa-legend-menu-button-transparent',
            htmlEncode: false,
            itemId: 'outlineColor',
            menu: [], 
            text: '\u00a0',
            width: 86,

            showMenu() {
                var swatch = this,
                    swatchEl = swatch.el,
                    legendView = this.up('map-legend'),
                    map = legendView.map,
                    legend = map.getLegendSettings();

                swatch.onMenuShow();

                SA.view.color.ColorWindow.show({
                    color: legend.outline.color,

                    hide() {
                        swatch.onMenuHide();
                    },

                    select(color) {
                        map.setLegend({
                            outline: Ext.applyIf({color}, legend.outline)
                        });
                    }
                }).showBy(swatchEl, 't-b?');
            }
        }
    ],

    beforeShow() {
        this.callParent();

        this.refresh();
    },

    refresh() {
        var outlineThicknessBtn = this.down('#outlineThickness'),
            outlineColorSwatch = this.down('#outlineColor'),
            legendView = this.up('map-legend'),
            map = legendView.map,
            legend = map.getLegendSettings();

        if (legend) {
            outlineThicknessBtn.setValue(legend.outline.width);

            outlineColorSwatch.setText(this.colorTpl.apply(legend.outline.color));
        }
    }
});